import React, {Component} from 'react';

export default class BookInfo extends Component {
	render() {
		return (
			<div className="bookstore-info col-xs-12 col-sm-6 col-md-8">
				<h3 className="book-title">
					<a href={ this.props.bookLink } dangerouslySetInnerHTML={ {__html: this.props.bookTitle} } />
				</h3>
				<div dangerouslySetInnerHTML={ {__html: this.props.bookDescription} } />
			</div>
		);
	}
}